export default __webpack_public_path__ + "static/media/globe.ddca1f16.gif";